import React from 'react';

import { Typography } from '@mui/material';
import { ActionTypeToTableActionLabel } from 'app/shared/modules/LoanRoles/LoanRolesHistory/LoanRolesHistoryTable.constants';
import dayjs from 'dayjs';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { HistoryFallback } from 'constants/history';

export const loanTagsHistoryConfig = {
  tagName: {
    label: 'Loan Tag',
    width: '32%',
    colSpan: ({ tagName }) => tagName?.colSpan,
    content: ({ tagName }) =>
      tagName?.content ?? (
        <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
          {tagName}
        </Typography>
      ),
  },
  date: {
    label: 'Date',
    width: '22%',
    content: ({ date }) => (
      <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
        {dayjs(date).format(COMMON_DATETIME_FORMAT)}
      </Typography>
    ),
  },
  modifiedBy: {
    label: 'Modified By',
    width: '22%',
    content: ({ modifiedBy }) => (
      <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
        {modifiedBy ?? HistoryFallback.SYSTEM}
      </Typography>
    ),
  },
  action: {
    label: 'Action',
    width: '12%',
    content: ({ action }) => (
      <Typography data-truncated className="truncate" color="text.primary" variant="regular14">
        {ActionTypeToTableActionLabel[action]}
      </Typography>
    ),
  },
};
